var map = {
	"./HTML5.svg": 934,
	"./actix.svg": 935,
	"./aiohttp.svg": 936,
	"./android.svg": 937,
	"./angularjs.svg": 938,
	"./app-engine.svg": 939,
	"./apple.svg": 940,
	"./aws.svg": 941,
	"./awslamda.svg": 942,
	"./azure.svg": 943,
	"./backbone.svg": 944,
	"./blazor.svg": 945,
	"./bootstrap.svg": 946,
	"./bottle.svg": 947,
	"./capacitor.svg": 948,
	"./celery.svg": 949,
	"./chalice.svg": 950,
	"./clojure.svg": 951,
	"./connect.svg": 952,
	"./cordova.svg": 953,
	"./cryengine.svg": 954,
	"./csharp.svg": 955,
	"./dart.svg": 956,
	"./default.svg": 957,
	"./django.svg": 958,
	"./dotnet.svg": 959,
	"./dotnetcore.svg": 960,
	"./dotnetfx.svg": 961,
	"./electron.svg": 962,
	"./elixir.svg": 963,
	"./ember.svg": 964,
	"./express.svg": 965,
	"./falcon.svg": 966,
	"./flask.svg": 967,
	"./flutter.svg": 968,
	"./fsharp.svg": 969,
	"./gatsby.svg": 970,
	"./gcp.svg": 971,
	"./go.svg": 972,
	"./godot.svg": 973,
	"./google.svg": 974,
	"./java.svg": 975,
	"./javascript.svg": 976,
	"./koa.svg": 977,
	"./kotlin.svg": 978,
	"./laravel.svg": 979,
	"./logback.svg": 980,
	"./nativec.svg": 981,
	"./nextjs.svg": 982,
	"./nodejs.svg": 983,
	"./perl.svg": 984,
	"./php.svg": 985,
	"./pyramid.svg": 986,
	"./python.svg": 987,
	"./qt.svg": 988,
	"./rails.svg": 989,
	"./react.svg": 990,
	"./redis.svg": 991,
	"./redux.svg": 992,
	"./ruby.svg": 993,
	"./rust.svg": 994,
	"./scala.svg": 995,
	"./sentry.svg": 996,
	"./serverless.svg": 997,
	"./sinatra.svg": 998,
	"./spring.svg": 999,
	"./springboot.svg": 1000,
	"./stride3d.svg": 1001,
	"./swift.svg": 1002,
	"./symfony.svg": 1003,
	"./tornado.svg": 1004,
	"./tryton.svg": 1005,
	"./unity.svg": 1006,
	"./uno.svg": 1007,
	"./unreal.svg": 1008,
	"./vue.svg": 1009,
	"./xamarin.svg": 1010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1144;